import React from "react";
import {Sidebar} from "@emburse/ui-core";
import {CheckCircleIcon, Icon} from '@emburse/ui-essentials';
import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate} from 'react-router';
import {BaseConfigurationContext} from "shared/context/BaseConfigurationContext";
import './NavBar.css';

export interface NavItem {
    textKey: string;
    route: string;
    showCheckCircle?: boolean;
}

export interface NavBarProps {
    items: NavItem[];
    isAuthenticated?: boolean;
}

export const NavBar = ({items, isAuthenticated = false}: NavBarProps) => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const {pathname} = useLocation();
    const {isInsideEmbark, basePath} = React.useContext(BaseConfigurationContext);

    const checkCircleIcon: React.ReactElement = <Icon data-qa="account-credentials-check-circle-icon" iconUrl={CheckCircleIcon} style={{color: "#218358"}}/>;

    return <Sidebar
        className={"removeBorderRight"}
        variant="permanent"
        sx={[
            !isInsideEmbark && {
                '& > .MuiDrawer-paper': {
                    top: '61px'
                }
            }
        ]}
        sidebarMenu={{
            menus: [
                {
                    tabMenu: {
                        sections: [
                            {
                                items: items.map(item => ({
                                    text: t(item.textKey),
                                    ...(item.showCheckCircle && isAuthenticated ? {icon: checkCircleIcon} : undefined),
                                    customAttr: {'data-qa': item.route.replace(/^\//, '') + '-left-bar'},
                                    selected: pathname === basePath + item.route || pathname === item.route,
                                    onClick: () => navigate(basePath + item.route),
                                }))
                            }
                        ]
                    }
                }
            ]
        }} />;
};